import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CamerasComponent } from '@componentes/cameras/cameras.component';
import { MapaComponent } from '@componentes/mapa/mapa.component';
import { MapasGeoComponent } from '@componentes/mapasgeo/mapasgeo.component';
import { MeteorologiaComponent } from '@componentes/meteorologia/meteorologia.component';
import { PiscinaoDetalheComponent } from '@componentes/piscinao_detalhe/piscinao_detalhe.component';
import { PiscinoesComponent } from '@componentes/piscinoes/piscinoes.component';
import { ReportsComponent } from '@componentes/reports/reports.component';
import { TuneisComponent } from '@componentes/tuneis/tuneis.component';
import { AuthAdminGuard } from './helpers/auth-admin.guard';

const autenticacaoModule = () => import('@componentes/autenticacao/autenticacao/autenticacao.module').then(x => x.AutenticacaoModule);
const configuracaoModule = () => import('@componentes/configuracoes/configuracoes.module').then(x => x.ConfiguracoesModule);
const usuariosModule = () => import('@componentes/autenticacao/usuarios/usuarios.module').then(x => x.UsuariosModule);

const routes: Routes = [
  {
    path: 'conta', loadChildren: autenticacaoModule,
    data: { modulo: '' }
  },
  {
    path: 'reports', component: ReportsComponent, canActivate: [AuthAdminGuard],
    data: { modulo: 'Monitor' }
  },
  {
    path: 'cameras', component: CamerasComponent, canActivate: [AuthAdminGuard],
    data: { modulo: 'Monitor' }
  },
  {
    path: 'piscinoes', component: PiscinoesComponent, canActivate: [AuthAdminGuard],
    data: { modulo: 'Monitor' }
  },
  {
    path: 'piscinao_detalhe/:id', component: PiscinaoDetalheComponent, canActivate: [AuthAdminGuard],
    data: { modulo: 'Monitor' }
  },
  {
    path: 'mapa', component: MapaComponent, canActivate: [AuthAdminGuard],
    data: { modulo: 'Monitor' }
  },
  {
    path: 'meteorologia', component: MeteorologiaComponent, canActivate: [AuthAdminGuard],
    data: { modulo: 'Monitor' }
  },
  {
    path: 'tuneis', component: TuneisComponent, canActivate: [AuthAdminGuard],
    data: { modulo: 'Monitor' }
  },
  {
    path: 'mapasgeo', component: MapasGeoComponent,
    data: { modulo: 'mapasgeo' }
  },
  {
    path: 'configuracoes', loadChildren: configuracaoModule, canActivate: [AuthAdminGuard],
    data: { animation: 'Configurações', modulo: 'Administração de Usuários' } 
  },
  {
    path: 'usuario', loadChildren: usuariosModule, canActivate: [AuthAdminGuard],
    data: { modulo: 'Administração de Usuários' }
  },
  { path: '', redirectTo: '/reports', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
